import { useTranslate } from '@agilepoint/wat-react';
import { useNotificationEvents } from '@agilepoint/wat-react-ux';
import { TextBoxField, ToggleInputField } from '@agilepoint/wat-react-ux-form-fields';
import { StyledPrimaryButton, StyledStackPanel } from 'common';
import { RichTextField } from 'common/components/form-fields/rich-text-field';
import { IAnnouncementParam } from 'modules/shared/queries';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import styled, { createGlobalStyle } from 'styled-components';
import { FooterContainer } from '../user-settings';

interface IFormFields {
    title: string;
    subTitle: string;
    description: string;
    status: boolean;
    content: string;
}

interface ICreateAnnouncementProps {
    saveAnnouncementInfo: (formData: IAnnouncementParam) => Promise<any>;
    removePopup?: (id: string) => void;
    popupId: string;
}

const StyledToggleInputField = styled(ToggleInputField)`
    width: 100%;
    padding: 12px;
`;
// Note: temp code
const CreateAnnouncementFormGlobalStyle = createGlobalStyle`
    .ap-popup-content {
        padding: 22px 28px 16px 30px !important;
    }
`;

export function CreateAnnouncementForm(props: ICreateAnnouncementProps) {
    const { saveAnnouncementInfo, removePopup, popupId } = props;
    const [isSavingData, setIsSavingData] = React.useState(false);
    const { handleSubmit } = useFormContext<IFormFields>();
    const { showNotifications } = useNotificationEvents();
    const translate = useTranslate();

    const sucessMessage = popupId === 'edit-announcement' ? translate('modules.userActions.notifications.createNotification.messages.notificationSave')
        : translate('modules.userActions.notifications.createNotification.messages.notificationSuccess');

    const saveAnnouncementHandler = React.useCallback((args: IFormFields) => {
        setIsSavingData(true);
        const { title, status, subTitle, content } = args;
        const intStatus = status ? 1 : 0;
        saveAnnouncementInfo({
            title,
            content,
            // description,
            status: intStatus,
            subTitle,
            deviceType: ''
        }).then((r) => {
            setIsSavingData(false);
            removePopup && removePopup(popupId);
            showNotifications({ message: sucessMessage, type: 'success' });
        }).catch((err) => {
            setIsSavingData(false);
            showNotifications({ message: err, type: 'error' });

        });
    }, [saveAnnouncementInfo, removePopup, popupId, showNotifications, sucessMessage]);

    return (
        <>
            <CreateAnnouncementFormGlobalStyle />
            <StyledStackPanel width='100%' padding='0px 0px 16px 0px' height='100%' orientation="vertical" justifyContent='center' alignment='center'>
                <TextBoxField name="title" label={translate('modules.userActions.notifications.createNotification.title')} title={translate('modules.userActions.notifications.createNotification.title')}
                    validationRules={{ required: translate('modules.userActions.createAnnouncement.messages.titleRequired') }} />
                <TextBoxField name="subTitle" label={translate('modules.userActions.notifications.createNotification.subTitle')} title={translate('modules.userActions.notifications.createNotification.subTitle')}
                    validationRules={{ required: translate('modules.userActions.createAnnouncement.messages.subTitleRequired') }} />
                {/* <TextAreaField name="description" label="Description" /> */}
                <StyledToggleInputField name='status' label={translate('modules.userActions.notifications.createNotification.status')} title={translate('modules.userActions.notifications.createNotification.status')} size="medium" labelPosition="left" />
                <RichTextField name="content" label={translate('modules.userActions.notifications.createNotification.content')} title={translate('modules.userActions.notifications.createNotification.content')} />
            </StyledStackPanel>
            <FooterContainer width="100%" justifyContent="flex-end" gap="12" padding='16px 0px 16px 0px'>
                <StyledPrimaryButton disabled={isSavingData} label={translate('app:common.actions.save')} onClick={handleSubmit(saveAnnouncementHandler)} />
            </FooterContainer>
        </>
    );
}
